__turbopack_context__.v({
  "hoveredTitle": "CardInfo-module-scss-module__glgz7a__hoveredTitle",
  "textColor": "CardInfo-module-scss-module__glgz7a__textColor",
});
